import AbstractEntity from "~/ts/library/AbstractEntity";

export default class PlatformEvent extends AbstractEntity {
    id!: string;
    descr!: string;
    typeId?: string;
}